var _excluded = ["desc", "focusable", "title", "iconName", "className"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { string, bool } from 'prop-types';
import classNames from 'classnames';
var svg = /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32"
}, /*#__PURE__*/React.createElement("path", {
  d: "M22.604 28H9.402a.396.396 0 00-.396.396V30H23v-1.604a.396.396 0 00-.396-.396zm5.56-21.336H24V3.265a.348.348 0 00-.25-.34A29.262 29.262 0 0016.002 2a29.262 29.262 0 00-7.745.924.348.348 0 00-.251.341v3.4h-4.17A.836.836 0 003 7.5c0 4.94 4.477 9.336 8.005 9.336v-.044A15.605 15.605 0 0015.003 20v3c-1.175 0-3.998.953-3.998 2.13V27H21v-1.87c0-1.177-2.822-2.13-3.998-2.13v-3a15.604 15.604 0 003.993-3.202v.038C24.523 16.836 29 12.44 29 7.5a.836.836 0 00-.835-.836zM4.721 8.336h3.286v1.06a10.428 10.428 0 001.555 5.45 8.485 8.485 0 01-4.841-6.51zm17.725 6.507A10.428 10.428 0 0024 9.396v-1.06h3.28a8.486 8.486 0 01-4.833 6.507z"
}));

var Icon = function Icon(_ref) {
  var desc = _ref.desc,
      _ref$focusable = _ref.focusable,
      focusable = _ref$focusable === void 0 ? false : _ref$focusable,
      title = _ref.title,
      iconName = _ref.iconName,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: String(focusable),
    className: classNames('rds-svg--cup-icon', className)
  }, rest, svg.props), title && /*#__PURE__*/React.createElement("title", null, title), desc && /*#__PURE__*/React.createElement("desc", null, desc), svg.props.children);
};

Icon.propTypes = {
  desc: string,
  focusable: bool,
  title: string,
  iconName: string,
  className: string
};
Icon.displayName = 'CupIcon';
export default Icon;